import '../../scss/forms.scss';
import './_style.scss';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'react-select/dist/react-select.min.css';

import React, { useCallback, useEffect, useRef } from 'react';
import Barcode from 'react-barcode';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import {
  Button, Card, CardBody, CardHeader, Col, Label, Row,
} from 'reactstrap';
import {
  GridDinamico,
  dynamicFilterStore,
} from '@newspacebpo/newspace-react-grid-filter-bfveic';

import logoSrc from '../../assets/img/brand/logobf.png';
import { LOGS } from '../../constants/logs';
import * as logsActions from '../../store/ducks/r_logs/actions';
import { dateHourToBr } from '../../util/date';
import ImprimirProtocoloPrint from './print';
import { printStyle } from './print-style';

const Imprimir = () => {
  const printRef = useRef();
  const {
    dados,
    id,
  } = useSelector(({ visualizarProtocolo }) => visualizarProtocolo);

  const {
    data,
  } = dynamicFilterStore.getState().dynamicFilters;

  const dispatch = useDispatch();
  const registerRequest = useCallback((payload) => dispatch(logsActions.registerRequest(payload)), [dispatch]);

  const onBeforePrint = useCallback(() => {
    if (!id) return;

    registerRequest({
      service: 'protocolo',
      action: LOGS.ACTIONS_TYPE.PROTOCOLO.IMPRIMIR,
      data: { _id: id, protocolo: dados.NumeroProtocolo },
    });
  }, [registerRequest, id, dados.NumeroProtocolo]);

  const onPrint = useCallback(useReactToPrint({
    content: () => printRef.current,
    copyStyles: true,
    onBeforePrint,
    pageStyle: printStyle,
  }), [onBeforePrint]);

  useEffect(() => {
    onPrint();
  }, [onPrint]);

  return (
    <div className="protocolo-consulta__imprimir">
      <Card>
        <CardHeader>
          <strong>Imprimir Protocolo</strong>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6">
              <img className="barlogo" src={logoSrc} alt="Logo" />
            </Col>
            <Col sm="6" className="text-right">
              <Barcode
                value={dados.NumeroProtocolo}
                displayValue={false}
                format="CODE128"
                height={50}
                width={3}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={6} sm={6} md={6}>
              <Label>Protocolo: </Label>
              <Label className="m-1">{dados.NumeroProtocolo}</Label>
            </Col>
            <Col xs={6} sm={6} md={6}>
              <Label>Data/Hora da Geração: </Label>
              <Label className="m-1">
                {dateHourToBr(dados.DataGeracao)}
              </Label>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col xs={6} sm={6} md={6}>
              <Label>Tipo Protocolo: </Label>
              <Label className="m-1">{dados.TipoProtocolo}</Label>
            </Col>
            <Col xs={6} sm={6} md={6}>
              <Label>Status: </Label>
              <Label className="m-1">{dados.StatusRecepcao}</Label>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col xs={6} sm={6} md={6}>
              <Label>Envelope: </Label>
              <Label className="m-1">{dados.NumeroEnvelope}</Label>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <Label>Responsável pela Geração:</Label>
              <Label className="m-1">{dados.UsuarioResponsavel}</Label>
            </Col>
            <Col sm={12} md={12}>
              <Label className="label">Total de Contratos: </Label>
              <Label className="m-1 label">{data.length}</Label>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col sm="12" md="9" className="mt-1 text-right">
              <Button onClick={onPrint}>Imprimir</Button>
            </Col>
          </Row>
          <Row className="row_protocolo">
            <Col>
              <GridDinamico pagination={false} />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ImprimirProtocoloPrint
        ref={printRef}
        items={data}
        envelope={dados.NumeroEnvelope}
        protocolo={dados.NumeroProtocolo}
        tpProtocolo={dados.TipoProtocolo}
        dataGer={dados.DataGeracao}
        responsavelGer={dados.UsuarioResponsavel}
        statusRec={dados.StatusRecepcao}
      />
    </div>
  );
};

export default Imprimir;
